// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Dropzone_dropzone__2A8-M","label":"Dropzone_label__3VHOg","default":"Dropzone_default__2Q5rp"};